// src/components/Header.jsx
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";

// fallback لو مفيش لوجو
import defaultLogo from "../assets/hero-illustration.png";

function Header() {
  const { logo } = useContext(GlobalContext);

  return (
    <header className="header">
      <div className="header__logo">
        <img
          src={"./img/WhatsApp Image 2025-10-01 at 7.56.44 PM.jpeg"}
          alt="Logo"
          style={{ height: "50px" }}
        />
      </div>
<nav className="header__nav">
  <a href="#about" className="header__link">معلومات عن الشركة</a>
  <a href="#origin" className="header__link">نشأتها</a>
  <a href="#mission" className="header__link">الرسالة</a>
  <a href="#vision" className="header__link">الرؤية</a>
  <a href="#values" className="header__link">الخدماتنا</a>
  <a href="#portfolio" className="header__link">اعمال الشركة</a>
  <a href="#contact" className="header__link">تواصل معنا</a>
</nav>
    </header>
  );
}

export default Header;
